import { render } from "./video-gallery.vue?vue&type=template&id=089aedf2&scoped=true"
import script from "./video-gallery.vue?vue&type=script&lang=js"
export * from "./video-gallery.vue?vue&type=script&lang=js"

import "./video-gallery.vue?vue&type=style&index=0&id=089aedf2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089aedf2"]])

export default __exports__